import { call, put, takeLatest } from "redux-saga/effects";
import { DetailStylingActions, GET_DETAIL_STYLING } from "@redux/reducer";
import {
  BRAND_LIST,
  COUNTRY,
  DetailProductsUgcType,
  DetailStylingPayload,
  LANGUAGE,
  ProductCoordinateUgcType,
  ProductDetailResponseHandType,
  ProductUgcType,
  StylehintListUgcPayload,
  StylehintListUgcResponse,
  StylingDetailType,
  StylingOfficialDetailUgcResponse
} from "@type/index";
import request from "@util/net/request";
import handRequest from "@util/net/hand";
import axios, { AxiosResponse } from "axios";
import qs from "qs";
import {
  StylingOfficialDetailMapper,
  StylingStylehintDetailMapper
} from "@util/net/queryParameters";
import { getProductCode } from "@util/helpers";
import store from "@redux/store";
import { isSitOrUat, isUQHK } from "@util/country";

export function* getDetailStylingSaga(action: {
  payload: DetailStylingPayload;
}) {
  try {
    const { brand_name, region, language } = store.getState().config;
    const payload: DetailStylingPayload = action.payload;
    yield put(DetailStylingActions.setDetailStylingErrorCode(""));
    yield put(DetailStylingActions.getDetailStylingLoading(true));
    if (payload.type === "sb") {
      const res: AxiosResponse<StylingOfficialDetailUgcResponse> = yield call(
        request.get,
        `/official/styles/${payload.styleId}`,
        {
          params: {
            content_language:
              language === LANGUAGE.ENGB
                ? "en-US"
                : `zh-${region.toUpperCase()}`
          }
        }
      );
      if (res.data.status === "ok") {
        if (
          res.data.result.style &&
          res.data.result.style.image_original !== ""
        ) {
          const coordinate: Array<ProductCoordinateUgcType> =
            res.data.result.coordinate;
          let codes: Array<string> = [];
          if (coordinate.length > 0) {
            coordinate.map((c: ProductCoordinateUgcType) => {
              const arr: Array<ProductUgcType> | undefined = c.products;
              if (arr && arr.length > 0) {
                return arr.map((a: ProductUgcType) => {
                  let str = "";
                  if (a.product_link.length > 0) {
                    str = getProductCode(a.product_link);
                  }
                  if (str.length > 0) {
                    codes.push(str);
                  }
                  return arr;
                });
              } else {
                return [];
              }
            });
          }
          codes = Array.from(new Set(codes));
          try {
            let productApi = "";
            if (region === COUNTRY.TW) {
              productApi = `/p/product/i/product/styling/query/${language}`;
            } else if (brand_name === BRAND_LIST.GU && region === COUNTRY.HK) {
              productApi = "/product/styling/spu/list";
            } else if (brand_name === BRAND_LIST.UQ && region === COUNTRY.HK) {
              if (isSitOrUat()) {
                productApi = `/p/product/i/product/spu/styling/query/${language}`;
              } else {
                productApi = "/crm/product/styling/spu/list";
              }
            }
            const product: AxiosResponse<ProductDetailResponseHandType> =
              yield call(
                handRequest.post,
                productApi,
                codes,
                isUQHK(brand_name, region)
                  ? {
                      headers: {
                        langCode: language
                      }
                    }
                  : null
              );
            if (product.data.success) {
              const obj: StylingDetailType = StylingOfficialDetailMapper(
                res.data.result,
                product.data.resp
              );
              yield put(DetailStylingActions.getDetailStylingSuccess(obj));
            } else {
              yield put(DetailStylingActions.setDetailStylingErrorCode("503"));
            }
          } catch {
            yield put(DetailStylingActions.setDetailStylingErrorCode("503"));
          }
        } else {
          yield put(DetailStylingActions.setDetailStylingErrorCode("404"));
        }
      } else if (
        res.data.status === "nok" &&
        res.data.error &&
        res.data.error.code === 404
      ) {
        yield put(DetailStylingActions.setDetailStylingErrorCode("404"));
      } else {
        yield put(DetailStylingActions.setDetailStylingErrorCode("503"));
      }
    } else {
      const res: AxiosResponse<StylehintListUgcResponse> = yield call(
        request.get,
        "/contents/search",
        {
          params: {
            id_ugc_dist_content: [payload.styleId]
          },
          paramsSerializer: function (params: StylehintListUgcPayload) {
            return qs.stringify(params, { arrayFormat: "indices" });
          }
        }
      );
      if (res.data.result_count) {
        const arr: Array<DetailProductsUgcType> | undefined = res.data
          .content_list
          ? res.data.content_list[0].products
          : [];
        let codes: Array<string> = [];
        if (arr && arr.length > 0) {
          arr.map((a: DetailProductsUgcType) => {
            let str = "";
            if (a.ugc_item.product_link.length > 0) {
              str = getProductCode(a.ugc_item.product_link);
            }
            if (str.length > 0) {
              codes.push(str);
            }
            return arr;
          });
          codes = Array.from(new Set(codes));
          try {
            let productApi = "";
            if (region === COUNTRY.TW) {
              productApi = `/p/product/i/product/styling/query/${language}`;
            } else if (brand_name === BRAND_LIST.GU && region === COUNTRY.HK) {
              productApi = "/product/styling/spu/list";
            } else if (brand_name === BRAND_LIST.UQ && region === COUNTRY.HK) {
              productApi = "/crm/product/styling/spu/list";
            }
            const product: AxiosResponse<ProductDetailResponseHandType> =
              yield call(
                handRequest.post,
                productApi,
                codes,
                isUQHK(brand_name, region)
                  ? {
                      headers: {
                        langCode: language
                      }
                    }
                  : null
              );
            if (
              product.data.success &&
              res.data.content_list &&
              res.data.content_list?.length > 0
            ) {
              const obj: StylingDetailType = StylingStylehintDetailMapper(
                res.data.content_list[0],
                product.data.resp
              );
              yield put(DetailStylingActions.getDetailStylingSuccess(obj));
            } else {
              yield put(DetailStylingActions.setDetailStylingErrorCode("503"));
            }
          } catch {
            yield put(DetailStylingActions.setDetailStylingErrorCode("503"));
          }
        } else if (res.data.content_list && res.data.content_list.length > 0) {
          const obj: StylingDetailType = StylingStylehintDetailMapper(
            res.data.content_list[0],
            []
          );
          yield put(DetailStylingActions.getDetailStylingSuccess(obj));
        } else {
          yield put(DetailStylingActions.setDetailStylingErrorCode("404"));
        }
      } else if (res.data.result_count === 0) {
        yield put(DetailStylingActions.setDetailStylingErrorCode("404"));
      } else {
        yield put(DetailStylingActions.setDetailStylingErrorCode("503"));
      }
    }
  } catch (error) {
    if (!axios.isCancel(error)) {
      const errorCode = JSON.parse(JSON.stringify(error)).status || null;
      if (errorCode && errorCode.toString() === "404") {
        yield put(DetailStylingActions.setDetailStylingErrorCode("404"));
      } else {
        yield put(DetailStylingActions.setDetailStylingErrorCode("503"));
      }
    }
  }
}

export function* watchLoadDetailStylingSaga() {
  yield takeLatest<any>(GET_DETAIL_STYLING, getDetailStylingSaga);
}
